import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Shared axios instance. withCredentials sends the admin httpOnly cookie.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Member (passwordless) token helpers
const MEMBER_KEY = "tt_member_token";
export const getMemberToken = () => localStorage.getItem(MEMBER_KEY);
export const setMemberToken = (t) => localStorage.setItem(MEMBER_KEY, t);
export const clearMemberToken = () => localStorage.removeItem(MEMBER_KEY);
export const memberHeaders = () => {
  const t = getMemberToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};
